import React, { useContext } from 'react';
import GlobalContext from '../context/GlobalContext';
import AdminShell from './AdminShell';
import DeniedCard from './DeniedCard';

export default function BeheerPage() {
  const { currentUser, userLoading } = useContext(GlobalContext);

  if (userLoading) {
    return (
      <div className="page-shell flex items-center justify-center">
        <div className="card max-w-md w-full p-6 text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <h1 className="text-xl font-semibold mb-2">Laden...</h1>
          <p className="text-gray-600 dark:text-gray-400">Gebruikersgegevens worden geladen</p>
        </div>
      </div>
    );
  }

  if (!currentUser?.isAdmin) {
    return <DeniedCard />;
  }

  return (
    <AdminShell title="Beheer">
      <p className="section-label mb-4">Beheerfuncties</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="card p-5 hover:bg-gray-50 dark:hover:bg-gray-800/60 transition-colors">
          <h3 className="text-lg font-medium mb-2">Gebruikersbeheer</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">Beheer gebruikers, rollen en rechten</p>
          <a href="/gebruikers" className="btn-primary w-full">Gebruikers beheren</a>
        </div>
        <div className="card p-5 hover:bg-gray-50 dark:hover:bg-gray-800/60 transition-colors">
          <h3 className="text-lg font-medium mb-2">Bedrijvenbeheer</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">Beheer bedrijven en organisaties</p>
          <a href="/bedrijven" className="btn-primary w-full">Bedrijven beheren</a>
        </div>
      </div>
    </AdminShell>
  );
}
